/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const roleEnumEnum = {
  Manager: 1,
  Employee: 2,
} as const

export type RoleEnumEnum = (typeof roleEnumEnum)[keyof typeof roleEnumEnum]

export type RoleEnum = RoleEnumEnum